import { render, staticRenderFns } from "./scrappedValueDisplay.vue?vue&type=template&id=12bed53d&scoped=true"
import script from "./scrappedValueDisplay.vue?vue&type=script&lang=js"
export * from "./scrappedValueDisplay.vue?vue&type=script&lang=js"
import style0 from "./scrappedValueDisplay.vue?vue&type=style&index=0&id=12bed53d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bed53d",
  null
  
)

export default component.exports